// this component is used only in Executive and CEO dashboard


import styles from "./index.module.scss";

import { useTranslation } from "react-i18next";
import BarChartStacked from "../BarChartStacked";

function CoachingSubject({ country = false, data }) {
  const { t } = useTranslation();
  return (
    <div className={`${styles.row} ${styles.noBorder}`}>
      <h4
        className={`${styles.sectionHead} ${styles.alignLeft} ${styles.bold}`}
      >
        {t("dashboard.executive.coachingSubjects")}
      </h4>
      {data && data.length > 0 ? (
        <BarChartStacked
          colors={["#13C77A", "#E3F7EC", "#006929", "#8FDEB2"]}
          fontColors={["#fff", "#000000", "#fff", "#000000"]}
          legends={["Productivity", "Quality", "Adherence", "Behaviour"]}
          showTotal
          country={country}
          maxHeight="200px"
          data={data}
          labelXSize="large"
          labelX={
            country
              ? t("userManagement.country")
              : t("dashboard.coach.campaign")
          }
          labelY={t("dashboard.executive.avgCoachingHours")}
          showTooltip={true}
        />
      ) : (
        <div className={styles.noData}>{t("dashboard.noDataYet")}</div>
      )}
    </div>
  );
}

export default CoachingSubject;
